import { MarriageDetailAnscNotificationsResidentSubscriptionCrumbs } from 'subscription/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchMarriageDetailNotificationsCivilStatusShared from 'shell/components/shared/ansc-notifications/research-marriage/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchMarriageDetailNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchMarriageDetailNotificationsCivilStatusShared
        items={MarriageDetailAnscNotificationsResidentSubscriptionCrumbs()}
        scope={IdAmbito.Iscrizioni}
      />
    </Fragment>
  );
};

ResearchMarriageDetailNotificationsCivilStatusPage.displayName =
  'Research Marriage Detail Notifications CivilStatusPage component';

export default ResearchMarriageDetailNotificationsCivilStatusPage;
